import { reactive, watch } from 'vue'
import { runtimeConfig } from '@/config/runtimeEnv'

const initialState = {
    version: 2,
    user: null,
    isGuest: false,
} as any

const store = {
    state: reactive({ ...initialState }),

    _initClean(): void {
        for (const [key, value] of Object.entries(initialState)) {
            this.state[key] = value
        }
    },

    init(): void {
        if (localStorage.getItem('appState')) {
            const storedState = JSON.parse(localStorage.getItem('appState') as string)
            if (storedState.version !== initialState.version) {
                this._initClean()
            }
            else {
                for (const key of Object.keys(initialState)) {
                    this.state[key] = storedState[key]
                }
            }
        }
        else {
            this._initClean()
        }
    },

    setUser(user: any, isGuest = false): void {
        this.state.user = user
        this.state.isGuest = !!isGuest
    },

    clearLocalStorage(): void {
        localStorage.clear()
        this._initClean()
    },
}

watch(store.state, (state: any) => {
    const supabaseURL = runtimeConfig.supabaseUrl
    const hostname = new URL(supabaseURL).hostname
    const projectRef = hostname.split('.')[0]
    const authTokenKey = `sb-${projectRef}-auth-token`
    if (localStorage.getItem(authTokenKey)) {
        localStorage.setItem('appState', JSON.stringify(state))
    }
    else {
        localStorage.removeItem('appState')
    }
})

store.init()

export default store
